
   const Data = [
    {
        product_id : 1,
        product_url : "https://i5.walmartimages.com/seo/SAMSUNG-Galaxy-Watch-Bluetooth-Smart-Watch-46mm-Silver-SM-R800NZSAXAR_fd4ac977-2091-48d8-9c42-e4bd76c25860_2.1e08fbcdac48c4ccfbef70130eef5fbf.png?odnHeight=768&odnWidth=768&odnBg=FFFFFF",
        product_description : "Galaxy Watch",
        product_quantity : 0,
        product_price :240
    },
    {
        product_id : 2,
        product_url : "https://i5.walmartimages.com/asr/c761828d-f59d-4d87-a380-33740e087477.12423ff52be2c3671d251794ff0afca0.jpeg",
        product_description : "Dell - Inspiron 15.6",
        product_quantity : 0,
        product_price :563
    },
    {
        product_id : 3,
        product_url : "https://i5.walmartimages.com/seo/Samsung-Galaxy-S23-Ultra-5G-Dual-S918B-512GB-12GB-RAM-GSM-Unlocked-Black_a77b9342-adda-4ed0-a9bd-2a3a80c29e21.9b9469de053b4157eb544c0267dbbca2.jpeg?odnHeight=2000&odnWidth=2000&odnBg=FFFFFF",
        product_description : "Samsung Galaxy S23 Ultra 5G Dual",
        product_quantity : 0,
        product_price :1055
    },
    {
        product_id : 4,
        product_url : "https://usplworld-static.s3.ap-south-1.amazonaws.com/static/img/wrogn/products/product_detail/WNTS1198/2.jpeg",
        product_description : "Wrogn t-shirt",
        product_quantity : 0,
        product_price :20
    },
    {
        product_id : 5,
        product_url : "https://images.journeys.com/images/products/1_686262_ZM_SSHERO.JPG",
        product_description : "Adidas Shoe- Cloud White",
        product_quantity : 0,
        product_price :59
    },
    {
        product_id : 6,
        product_url : "https://m.media-amazon.com/images/I/61WFNqf8hVL._AC_UF894,1000_QL80_.jpg",
        product_description : "Sony WH-XB910N EXTRA BASS Noise Cancelling Headphone",
        product_quantity : 0,
        product_price :248
    },
    {
        product_id : 7,
        product_url : "https://www.ikea.com/us/en/images/products/malm-storage-bed-white__1154392_pe886041_s5.jpg?f=s",
        product_description : "MALM Storage bed, white, Full/Double",
        product_quantity : 0,
        product_price :659
    },
    {
        product_id : 8,
        product_url : "https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6008/6008009_sd.jpg;maxHeight=640;maxWidth=550",
        product_description : "KitchenAid - Artisan Series 5 Quart Tilt-Head Stand Mixer",
        product_quantity : 0,
        product_price :449
    },
    {
        product_id : 9,
        product_url : "https://cb2.scene7.com/is/image/CB2/EltonPolishedBrassGroupFHS21/$web_plp_card_mobile$/201104171616/elton-polished-brass-bath-accessories.jpg",
        product_description : "Modern Bathroom Accessories: Soap Dispensers, Vanity Trays & Tissue Box Covers ",
        product_quantity : 0,
        product_price :359
    },
    {
        product_id : 10,
        product_url : "https://axebat.com/cdn/shop/products/2023AxeAvengeProHeroImage.148K_1024x1024@2x.jpg?v=1688649216",
        product_description : "Avenge Pro USSSA (-10) 2-3-4",
        product_quantity : 0,
        product_price :399
    } ];

    export default Data;

